import { render, staticRenderFns } from "./DescriptionThirdApp.vue?vue&type=template&id=061e7025"
import script from "./DescriptionThirdApp.vue?vue&type=script&lang=ts"
export * from "./DescriptionThirdApp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports